import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  max-width: 750px;
  margin: 20px auto 24px;
  background: rgba(3, 253, 221, 0.5);
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  border-radius: 24px;
`;
